<template>

    <div>
      <dialog-add-user v-if="me" ref="dialogAddUser" :is_business="me.company_type != 'agency'"></dialog-add-user>
  
      <panel-navigation>
  
        <div class="float-right ml-5 -mt-1">
          <!-- <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2" @click="$refs.dialogAddUser.createUser(); $refs.dialogAddUser.show()" style="margin-top: -5px;"><i class="fa fa-plus mr-2"> </i> ADD USER</div> -->
        </div>
  
        <div class="container flex flex-row items-center justify-between">
            <h1 class="text-lg font-semibold mt-5">Webhook Settings</h1>
            <!-- <div class="border-1 border-blue text-primary text-xs text-bold px-4 py-2 rounded cursor-pointer float-right" @click="$router.push({ name: 'adminusers'})" style="margin-top: -5px;"><i class="fa fa-arrow-left mr-2"> </i> BACK</div> -->
        </div>
  
        <hr class="border-b border-gray-100 mb-3">
  
        <v-skeleton-loader v-if="!search" type="article, article, article"></v-skeleton-loader>

  
        <template v-else>
          <div class="dashboard-box">
            <v-card
              class=""
              tile
            >
              <div class="">

                <v-container  v-if="search">
                    <div class="flex flex-1">
                      
                        <div class="w-2/5 p-3 border-r border-gray-200">
                            <h2 class="text-lg font-semibold mb-2">Webhook URL</h2>
                            <v-text-field 
                            v-model="webhookUrl" 
                            label="Webhook URL" 
                            outlined 
                            class="mb-2"
                            />
                            <div class="flex justify-between">
                            <v-btn @click="updateWebhook" :class="{'spinner': saving}" color="primary">Update Webhook</v-btn>
                            </div>
                        </div>

                        
                        <div class="w-3/5 p-3">
                            <h2 class="text-lg font-semibold mb-2">Default JSON Data</h2>
                            <textarea
                            v-model="jsonData"
                            class="w-full h-full border border-gray-300 p-2 rounded-md code-editor mb-3"
                            placeholder="Edit your JSON data here"
                            ></textarea>
                            <v-btn @click="testWebhook(jsonData)" :class="{'spinner': testingWebhook}" color="secondary">Test Webhook</v-btn>
                        </div>
                    </div>

                    <div class="flex flex-1 mt-5 p-2">
                      
                      <div class="w-1/2 p-2 border-r border-gray-200">
                        <h2 class="text-lg font-semibold mb-2">Sign up flow step 1</h2>
                          <textarea
                            v-model="signup_flow_step_1"
                            class="w-full h-full border border-gray-300 p-2 rounded-md code-editor mb-3"
                            placeholder="Edit your JSON data here"
                          ></textarea>
                          <v-btn @click="testWebhook(signup_flow_step_1)" :class="{'spinner': testingWebhook}" color="secondary">Test Webhook</v-btn>
                      </div>

                      
                      <div class="w-1/2 p-2">
                          <h2 class="text-lg font-semibold mb-2">Sign up flow step 2</h2>
                          <textarea
                            v-model="singup_flow_step_2"
                            class="w-full h-full border border-gray-300 p-2 rounded-md code-editor mb-3"
                            placeholder="Edit your JSON data here"
                          ></textarea>
                          <v-btn @click="testWebhook(singup_flow_step_2)" :class="{'spinner': testingWebhook}" color="secondary">Test Webhook</v-btn>
                      </div>
                    </div>


                    <div class="flex flex-1 mt-5 p-2">
                      
                      <div class="w-1/2 p-2 border-r border-gray-200">
                        <h2 class="text-lg font-semibold mb-2">Sign up flow step 3</h2>
                          <textarea
                            v-model="singup_flow_step_3"
                            class="w-full h-full border border-gray-300 p-2 rounded-md code-editor mb-3"
                            placeholder="Edit your JSON data here"
                          ></textarea>
                          <v-btn @click="testWebhook(singup_flow_step_3)" :class="{'spinner': testingWebhook}" color="secondary">Test Webhook</v-btn>
                      </div>

                      
                      <div class="w-1/2 p-2">
                          <h2 class="text-lg font-semibold mb-2">Registration Complete</h2>
                          <textarea
                            v-model="registration_complete"
                            class="w-full h-full border border-gray-300 p-2 rounded-md code-editor mb-3"
                            placeholder="Edit your JSON data here"
                          ></textarea>
                          <v-btn @click="testWebhook(registration_complete)" :class="{'spinner': testingWebhook}" color="secondary">Test Webhook</v-btn>
                      </div>
                    </div>

                    <div class="flex flex-1 mt-5 p-2">
                      
                      <div class="w-1/2 p-2 border-r border-gray-200">
                        <h2 class="text-lg font-semibold mb-2">Onboarding flow step1.1</h2>
                          <textarea
                            v-model="onboarding_flow_step1_1"
                            class="w-full h-full border border-gray-300 p-2 rounded-md code-editor mb-3"
                            placeholder="Edit your JSON data here"
                          ></textarea>
                          <v-btn @click="testWebhook(onboarding_flow_step1_1)" :class="{'spinner': testingWebhook}" color="secondary">Test Webhook</v-btn>
                      </div>

                      
                      <div class="w-1/2 p-2">
                          <h2 class="text-lg font-semibold mb-2">Onboarding flow step1.2</h2>
                          <textarea
                            v-model="onboarding_flow_step1_2"
                            class="w-full h-full border border-gray-300 p-2 rounded-md code-editor mb-3"
                            placeholder="Edit your JSON data here"
                          ></textarea>
                          <v-btn @click="testWebhook(onboarding_flow_step1_2)" :class="{'spinner': testingWebhook}" color="secondary">Test Webhook</v-btn>
                      </div>
                    </div>
                  

                    <div class="flex flex-1 mt-5 p-2">
                      
                      <div class="w-1/2 p-2 border-r border-gray-200">
                        <h2 class="text-lg font-semibold mb-2">Onboarding flow step1.3</h2>
                          <textarea
                            v-model="onboarding_flow_step1_3"
                            class="w-full h-full border border-gray-300 p-2 rounded-md code-editor mb-3"
                            placeholder="Edit your JSON data here"
                          ></textarea>
                          <v-btn @click="testWebhook(onboarding_flow_step1_3)" :class="{'spinner': testingWebhook}" color="secondary">Test Webhook</v-btn>
                      </div>

                      
                      <div class="w-1/2 p-2">
                          <h2 class="text-lg font-semibold mb-2">Onboarding flow step1.4</h2>
                          <textarea
                            v-model="onboarding_flow_step1_4"
                            class="w-full h-full border border-gray-300 p-2 rounded-md code-editor mb-3"
                            placeholder="Edit your JSON data here"
                          ></textarea>
                          <v-btn @click="testWebhook(onboarding_flow_step1_4)" :class="{'spinner': testingWebhook}" color="secondary">Test Webhook</v-btn>
                      </div>
                    </div>

                    <div class="flex flex-1 mt-5 p-2">
                      
                      <div class="w-1/2 p-2 border-r border-gray-200">
                        <h2 class="text-lg font-semibold mb-2">Onboarding flow step 2</h2>
                          <textarea
                            v-model="onboarding_flow_step2"
                            class="w-full h-full border border-gray-300 p-2 rounded-md code-editor mb-3"
                            placeholder="Edit your JSON data here"
                          ></textarea>
                          <v-btn @click="testWebhook(onboarding_flow_step2)" :class="{'spinner': testingWebhook}" color="secondary">Test Webhook</v-btn>
                      </div>

                      
                      <div class="w-1/2 p-2">
                          <h2 class="text-lg font-semibold mb-2">Onboarding flow step 3</h2>
                          <textarea
                            v-model="onboarding_flow_step3"
                            class="w-full h-full border border-gray-300 p-2 rounded-md code-editor mb-3"
                            placeholder="Edit your JSON data here"
                          ></textarea>
                          <v-btn @click="testWebhook(onboarding_flow_step3)" :class="{'spinner': testingWebhook}" color="secondary">Test Webhook</v-btn>
                      </div>
                    </div>


                    <div class="flex flex-1 mt-5 p-2">
                      
                      <div class="w-1/2 p-2 border-r border-gray-200">
                        <h2 class="text-lg font-semibold mb-2">Onboarding flow step 4</h2>
                          <textarea
                            v-model="onboarding_flow_step4"
                            class="w-full h-full border border-gray-300 p-2 rounded-md code-editor mb-3"
                            placeholder="Edit your JSON data here"
                          ></textarea>
                          <v-btn @click="testWebhook(onboarding_flow_step4)" :class="{'spinner': testingWebhook}" color="secondary">Test Webhook</v-btn>
                      </div>

                      
                      <div class="w-1/2 p-2">
                          <h2 class="text-lg font-semibold mb-2">Transaction Ipn hit</h2>
                          <textarea
                            v-model="transaction_hit"
                            class="w-full h-full border border-gray-300 p-2 rounded-md code-editor mb-3"
                            placeholder="Edit your JSON data here"
                          ></textarea>
                          <v-btn @click="testWebhook(transaction_hit)" :class="{'spinner': testingWebhook}" color="secondary">Test Webhook</v-btn>
                      </div>
                    </div>

                    <div class="flex flex-1 mt-5 p-2">
                      
                      <div class="w-1/2 p-2 border-r border-gray-200">
                        <h2 class="text-lg font-semibold mb-2">User Collaboration</h2>
                          <textarea
                            v-model="user_collaboration"
                            class="w-full h-full border border-gray-300 p-2 rounded-md code-editor mb-3"
                            placeholder="Edit your JSON data here"
                          ></textarea>
                          <v-btn @click="testWebhook(user_collaboration)" :class="{'spinner': testingWebhook}" color="secondary">Test Webhook</v-btn>
                      </div>

                    </div>
                </v-container>

            </div>
            </v-card>
          </div>

        </template>
      </panel-navigation>
    </div>
  
    
  </template>
  
  <script>
  import axios from 'axios'
  import { mapState } from 'vuex'
  import PanelNavigation from '@/components/PanelNavigation.vue'
  import MenuUserActions from '@/components/menus/menuUserActions.vue'
  import DialogAddUser from '@/components/dialogs/users/addUser.vue'
  import moment from 'moment'
  
  export default {
    metaInfo () {
      return {
        title: "Users | " + this.$appName
      }
    },
    components: {
      PanelNavigation,
      MenuUserActions,
      DialogAddUser
    },
    data() {
      return {
        search :null,
        webhookUrl: '', 
        jsonData: '',  
        saving:false,
        testingWebhook:false,
        signup_flow_step_1: `{
  "email": "contes.alexandru@yahoo.com",
  "event": "signUp",
  "step": "signup_flow_step1",
  "SIGNUP_FLOW_STEP1": {
    "email": "contes.alexandru@yahoo.com"
  }
}`,
singup_flow_step_2: `{
  "email": "contes.alexandru@yahoo.com",
  "event": "signUp",
  "step": "signup_flow_step2",
  "SIGNUP_FLOW_STEP2": {
    "FIRST_NAME": "Admin",
    "LAST_NAME": "Acc"
  }
}`,
singup_flow_step_3: `{
  "email": "contes.alexandru@yahoo.com",
  "event": "signUp",
  "step": "signup_flow_step3",
  "SIGNUP_FLOW_STEP3": {
    "BUSINESS": "Arsenyl LLC",
    "TIME_ZONE": "America/New_York"
  }
}`,
registration_complete: `{
  "FIRST_NAME": "Admin",
  "LAST_NAME": "Acc",
  "email": "contes.alexandru@yahoo.com",
  "step": "registration_complete",
  "STRIPE_STATUS": "canceled",
  "SUBSCRIPTION_NAME": "Unlimited Agency",
  "BILLING_AMOUNT": "0",
  "PAY_FAIL": "https://api.ravu.me/billing/portal/c65346ca-9689-482c-a0e0-0f518a24c7f5",
  "COMPANY_NAME": "Arsenyl LLC",
  "ACTIVE_PAID_SUBSCRIBERS": 11,
  "ACTIVE_STRIPE_REVENUE": "396.00",
  "FIRST_BUSINESS_SETUP_COUNT": 11,
  "COMPANY_TYPE": "agency",
  "TOTAL_SPENT": "0.00",
  "USING_STRIPE_INTEGRATION": "Yes",
  "WHITE_LABEL_DOMAIN_SETUP": "No",
  "LAST_LOGIN": "2024-11-05T07:09:22.000000Z",
  "TRANSACTION_STATUS": "succeeded",
  "TRANSACTION_DESCRIPTION": "(created by Stripe CLI)",
  "TRANSACTION_AMOUNT": 149,
  "TRANSACTION_FAILURE_REASON": null,
  "SIGNUP_FLOW_STEP1": {
    "email": "contes.alexandru@yahoo.com"
  },
  "SIGNUP_FLOW_STEP2": {
    "FIRST_NAME": "Admin",
    "LAST_NAME": "Acc"
  },
  "SIGNUP_FLOW_STEP3": {
    "BUSINESS": "Arsenyl LLC",
    "TIME_ZONE": "America/New_York"
  }
}`,
onboarding_flow_step1_1: `{
  "event": "onboarding",
  "step": "onboard_flow_step1.1",
  "email": "contes.alexandru@yahoo.com",
  "ONBOARD_FLOW_STEP1.2": "Get started - add basic information"
}`,
onboarding_flow_step1_2: `{
  "event": "onboarding",
  "step": "onboard_flow_step1.2",
  "email": "contes.alexandru@yahoo.com",
  "ONBOARD_FLOW_STEP1.2": "Get started - connect review platforms"
}`,
onboarding_flow_step1_3: `{
  "event": "onboarding",
  "step": "onboard_flow_step1.3",
  "email": "contes.alexandru@yahoo.com",
  "ONBOARD_FLOW_STEP1.3": "Get started - settings"
}`,
onboarding_flow_step1_4: `{
  "event": "onboarding",
  "step": "onboard_flow_step1.4",
  "email": "contes.alexandru@yahoo.com",
  "ONBOARD_FLOW_STEP1.3": "Get started - add contacts"
}`,
onboarding_flow_step2: `{
  "event": "onboarding",
  "step": "onboard_flow_step2",
  "email": "contes.alexandru@yahoo.com",
  "ONBOARD_FLOW_STEP2": "Get started - Review funnel"
}`,
onboarding_flow_step3: `{
  "event": "onboarding",
  "step": "onboard_flow_step3",
  "email": "contes.alexandru@yahoo.com",
  "ONBOARD_FLOW_STEP2": "Review campaign"
}`,
onboarding_flow_step4: `{
  "event": "onboarding",
  "step": "onboard_flow_step4",
  "email": "contes.alexandru@yahoo.com",
  "ONBOARD_FLOW_STEP2": "Review campaign"
}`,
transaction_hit: `{
  "FIRST_NAME": "Admin",
  "LAST_NAME": "Acc",
  "email": "contes.alexandru@yahoo.com",
  "step": "transaction",
  "STRIPE_STATUS": "canceled",
  "SUBSCRIPTION_NAME": "Unlimited Agency",
  "BILLING_AMOUNT": "0",
  "PAY_FAIL": "https://api.ravu.me/billing/portal/c65346ca-9689-482c-a0e0-0f518a24c7f5",
  "COMPANY_NAME": "Arsenyl LLC",
  "ACTIVE_PAID_SUBSCRIBERS": 11,
  "ACTIVE_STRIPE_REVENUE": "396.00",
  "FIRST_BUSINESS_SETUP_COUNT": 11,
  "COMPANY_TYPE": "agency",
  "TOTAL_SPENT": "0.00",
  "USING_STRIPE_INTEGRATION": "Yes",
  "WHITE_LABEL_DOMAIN_SETUP": "No",
  "LAST_LOGIN": "2024-11-05T07:09:22.000000Z",
  "TRANSACTION_STATUS": "succeeded",
  "TRANSACTION_DESCRIPTION": "(created by Stripe CLI)",
  "TRANSACTION_AMOUNT": 149,
  "TRANSACTION_FAILURE_REASON": null,
  "SIGNUP_FLOW_STEP1": {
    "email": "contes.alexandru@yahoo.com"
  },
  "SIGNUP_FLOW_STEP2": {
    "FIRST_NAME": "Admin",
    "LAST_NAME": "Acc"
  },
  "SIGNUP_FLOW_STEP3": {
    "BUSINESS": "Arsenyl LLC",
    "TIME_ZONE": "America/New_York"
  },
  "ONBOARD_FLOW_STEP1.1": "Get started - add basic information",
  "ONBOARD_FLOW_STEP1.2": "Get started - connect review platforms",
  "ONBOARD_FLOW_STEP1.3_1": "Get started - settings",
  "ONBOARD_FLOW_STEP1.3_2": "Get started - add contacts",
  "ONBOARD_FLOW_STEP2": "Review funnel",
  "ONBOARD_FLOW_STEP3": "Review campaign",
  "ONBOARD_FLOW_STEP4": "Add Widgets",
  "ONBOARD_FLOW_STEP5": "Social posting"
}`,
user_collaboration: `{
  "email": "contes.alexandru@yahoo.com",
  "event": "add_user",
  "step": "add_user",
  "account_type":"agency",
  "ADD_USER": {
    "parent_id": "126",
    "company_type": "user",
    "uuid": "965ad82d-1846-4551-9177-b562e63ad83f",
    "first_name": "Admin",
    "last_name": "Acc",
    "email": "contes.alexandru@yahoo.com",
    "company_name": "Arsenyl LLC",
    "updated_at": "2024-11-11T16:57:40.000000Z",
    "created_at": "2024-11-11T16:57:40.000000Z",
    "id": 9084
  }
}`


      }
    },
    computed: {
      ...mapState({
        me: state => state.me.me
      }),
      
    },
    methods: {
        async getSearch(){
            axios.get(process.env.VUE_APP_API_ENDPOINT + '/me/get-webhook', {
            headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt,
                },
        })
         .then(response => {
           
                this.search = response.data.data
                this.webhookUrl = response.data.data.webhook_url; 
                // this.jsonData = JSON.stringify(response.data.data.json, null, 2); 
                this.jsonData = response.data.data.json

            })
            .catch(error => {
             console.log(error)
            })
    },

    async updateWebhook() {
        this.saving = true;
      try {
        const respone = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/me/update-webhook', {
          webhook_url: this.webhookUrl,
        }, {
          headers: {
            Authorization: 'Bearer ' + this.$store.state.auth.jwt,
          },
        });
        this.saving = false;
        this.$swal('Webhook updated successfully!');
      } catch (error) {
        this.saving = false;
            if (error.response && error.response.status === 422) {
                const errors = error.response.data.errors;
                const errorMessage = Object.values(errors).flat().join(', '); 
                 this.$swal(`Validation Errors: ${errorMessage}`);
            } else {
                this.$swal('Failed to update webhook.');
            }
      }
    },
    async testWebhook(dynamicModal) {
      
        this.testingWebhook = true;
        try {
            const response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/me/test-webhook', {
            webhook_url: this.webhookUrl, 
            data: JSON.parse(dynamicModal) 
            }, {
            headers: {
                Authorization: 'Bearer ' + this.$store.state.auth.jwt,
            },
            });
            this.testingWebhook = false;
            this.$swal('Test webhook sent successfully!');
        } catch (error) {
          console.log(error.message)
            this.testingWebhook = false;
            if (error.response) {
                const errorMessage = error.response.data.message || 'Failed to send test webhook.';
                this.$swal(errorMessage);
            } else {
                this.$swal('Failed to send test webhook.');
            }
        }
    },

    formatDate: function(date) {
         return moment(String(date)).format('MM/DD/YYYY')
    },
    },
    mounted() {
        this.getSearch();
    }
  }
  </script>
  
  <style lang="scss" scoped>
  
  .styled-checkbox {
    position: absolute; // take it out of document flow
    opacity: 0; // hide it
  
    & + label {
      position: relative;
      cursor: pointer;
      padding: 0;
    }
  
    // Box.
    & + label:before {
      content: '';
      margin-right: 0px;
      display: inline-block;
      vertical-align: text-top;
      width: 20px;
      height: 20px;
      background: rgb(228, 228, 228);
    }
  
    // Box hover
    /*&:hover + label:before {
      background: #f35429;
    }*/
    
    // Box focus
    &:focus + label:before {
      
      border-width: 0;
    }
  
    // Box checked
    &:checked + label:before {
      background: #48bb78;
    }
    
    // Disabled state label.
    &:disabled + label {
      color: #b8b8b8;
      cursor: auto;
    }
  
    // Disabled box.
    &:disabled + label:before {
      box-shadow: none;
      background: #ddd;
    }
  
    // Checkmark. Could be replaced with an image
    &:checked + label:after {
      content: '';
      position: absolute;
      left: 5px;
      top: 9px;
      background: white;
      width: 2px;
      height: 2px;
      box-shadow: 
        2px 0 0 white,
        4px 0 0 white,
        4px -2px 0 white,
        4px -4px 0 white,
        4px -6px 0 white,
        4px -8px 0 white;
      transform: rotate(45deg);
    }
  }
  
  .btn-invite {
    background-color: #00ad9e;
  }
  
  table tbody tr {
    transition: all 0.1s linear;
  }
  
  table tbody tr:hover {
    background-color: rgb(245, 245, 245);
  }
  textarea {
        resize: none; 
        font-family: monospace; 
        height: 500px;
    }
    .code-editor {
        background-color: #1e1e1e;
        color: #d4d4d4;
        padding: 10px;
        font-family: Consolas, Courier New, monospace;
        font-size: 14px;
        line-height: 1.5;
        overflow-x: auto;
    }
  </style>
  